module.exports = ":host .color {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    content: \" \";\n    overflow: hidden;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-charts/scale-chart-legend/scale-chart-legend.component.css
// module id = ./src/app/assessment-charts/scale-chart-legend/scale-chart-legend.component.css
// module chunks = main